<!--
해외오더 결제방법 추가
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4>해외오더 결제방법 추가</h4>
            </div>

            <div class="uk-modal-body uk-padding-small" >
                <app-input-ex
                    class="uk-margin-bottom"
                    type="text"

                    v-model="method"
                    label="결제방법(카드번호)"
                    placeholder="카드번호 전체를 노출하지 마시고 “VISA-001”이런식으로 업체에서만 알아보실 수 있도록 입력하세요"

                    :validate-rules="{required: true}"
                    required
                    required-layout="label-left"
                > </app-input-ex>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    완료
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 사용자ID
             */
            userId: Number,
        },
        data: function () {
            return {
                // 결제방법
                method: null,
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             */
            form() {

                // 폼띄우기
                this.displayForm();
            },


            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/payment-methods',
                    data: {
                        '_token': this.csrfToken,
                        'user_id': this.userId,
                        'method': this.method,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>